// extracted by mini-css-extract-plugin
export default {"inputWrapper":"styles_inputWrapper__lKJ0X","lingualInput":"styles_lingualInput__42vpP"};